module.exports = __webpack_public_path__ + "static/media/fan-table.e6849d48.svg";